import { memo, useMemo } from 'react';
import { Button, Link } from "@heroui/react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useGetSingleCourseBySlugQuery } from "../../redux/apis/courseApi";

const CourseDetailsLayout = memo(() => {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const { data } = useGetSingleCourseBySlugQuery(slug);
  
  // Memoize the section list and path calculations
  const { sectionList, activePathBase } = useMemo(() => ({
    sectionList: data?.sections || [],
    activePathBase: pathname.split('/').slice(0, 3).join('/')
  }), [data?.sections, pathname]);

  return (
    <div className="sm:container sm:mx-auto pb-5">
      <div className="flex mt-20 justify-center gap-4 pt-2 mb-4">
        {sectionList.map((item) => {
          const itemPath = `/course/${slug}/${item.id}`;
          const isActive = pathname === itemPath;
          
          return (
            <Button
              className="text-2xl sm:text-3xl !py-6"
              variant={isActive ? "solid" : "bordered"}
              size="sm"
              color="danger"
              key={item.id}
              as={Link}
              href={itemPath}
            >
              {item.title}
            </Button>
          );
        })}
      </div>
      
      {/* Stable outlet container */}
      <div key={activePathBase}>
        <Outlet />
      </div>
    </div>
  );
});

export default CourseDetailsLayout;
